import { ExWindow } from '@ve/types';

declare let window: ExWindow;

export default (): boolean | null => window.appConfig.isMobileDomain ?? null;
